import React from "react";
import { func, bool, string } from "prop-types";
import { Formik } from "formik";

import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormHelperText from "@material-ui/core/FormHelperText";
import Face from "@material-ui/icons/Face";
import Lock from "@material-ui/icons/LockOutlined";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";

import Button from "../../components/Button";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import CardHeader from "../../components/Card/CardHeader";
import CardFooter from "../../components/Card/CardFooter";
import Input from "../../components/formik-fields/Input";
import { initialValues, validationSchema } from "./form-values";

import styles from "./styles";

const useStyles = makeStyles(styles);
const LoginForm2 = ({ onLogin, isLoading, error, hostAgency, redirect }) => {
  const classes = useStyles();
  const { name, logo, welcomeText, urlId } = hostAgency || {};

  //need to change or handle differently for production - check format for the url?
  const passwordResetText = "Please click here to reset your password";
  const passwordResetLink = `https://gofluently.com/${urlId}`;

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onLogin}
      validationSchema={validationSchema}
    >
      {({ handleSubmit, isValid }) => (
        <form onSubmit={handleSubmit}>
          <Card login>
            <CardActionArea>
              <CardMedia
                //image={logo ? true : false}
                className={`${classes.cardHeader} ${classes.textCenter}`}
                color="info"
              >
                {logo ? (
                  <img
                    src={logo}
                    alt={name}
                    style={{ maxHeight: "140px", maxWidth: "100%" }}
                  />
                ) : (
                  <h4 className={classes.cardTitle}>Log in</h4>
                )}
              </CardMedia>
            </CardActionArea>
            <CardBody>
              <h4>Interpreter Scheduling System</h4>
              {welcomeText ? (
                <p>welcomeText</p>
              ) : (
                <p>
                  Welcome to the <em>Interpreter Scheduling System (I2S2)</em>{" "}
                  for {name}. With an assigned username and password you can
                  request and schedule interpreting appointments. If you have
                  not been assigned a username and password, please contact your
                  administrator at {name} to obtain them. If {name} has assigned
                  you a username and password, please enter them below.
                </p>
              )}

              <Input name="username" label="User" icon={Face} />
              <Input
                name="password"
                type="password"
                label="Password"
                autoComplete="off"
                icon={Lock}
              />
            </CardBody>
            <CardFooter className={classes.footer}>
              {error && <FormHelperText error>{error}</FormHelperText>}
              {redirect && (
                <FormHelperText error>
                  <a href={passwordResetLink}>{passwordResetText} </a>
                </FormHelperText>
              )}
              <div className={classes.buttonWrapper}>
                <Button
                  disabled={!isValid}
                  type="submit"
                  color="info"
                  simple
                  size="lg"
                  block
                >
                  Let{"'"}s Go
                </Button>
                {isLoading && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </CardFooter>
          </Card>
        </form>
      )}
    </Formik>
  );
};

LoginForm2.propTypes = {
  onLogin: func.isRequired,
  isLoading: bool.isRequired,
  error: string,
  redirect: bool,
};

export default LoginForm2;
